import React, { useState } from 'react'
import UpdateBlogComponent from './UpdateBlogComponent'
import InfiniteScrollSentinel from './InfiniteScrollSentinel'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../Store/store';
import { setSelectedBlogData, setSelectedBlogId, updateSelectedBlogData } from '../../../Store/slices/blogSlice';
import { Box, Button, MenuItem, Modal, Select, Switch, TextField, Typography } from '@mui/material';
import { useTagsHook } from '../../../Hooks/communicators/useTagsHook';
import { useBlogsHook } from '../useBlogsHook';
import { useRecipesHook } from '../../../Hooks/communicators/useRecipesHook';
import { Checkbox } from '@mui/material';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function UpdateBlog() {
    const {
        allBlogs,
        selectedBlogId,
        selectedBlogData,
    } = useSelector((state: RootState) => state.blogs.value);

    const { 
        handleUpdate,
        handleUpdateFileChange1,
        handleUpdateFileChange2,
        handleUpdateFileChange3,
        updateUploading1,
        updateProgress1,
        updateUploading2,
        updateProgress2,
        updateUploading3,
        updateProgress3,
        fetchAllBlogs,
        fetchMoreBlogs,
        searchBlogs,
        loadingMore,
        hasMoreBlogs,
    } = useBlogsHook();

    const [searchQuery, setSearchQuery] = useState('');

    // Quill editor configuration
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'align': [] }],
            ['link', 'image'],
            ['clean']
        ],
    };

    const formats = [
        'header', 'bold', 'italic', 'underline', 'strike',
        'color', 'background', 'list', 'bullet', 'indent',
        'align', 'link', 'image'
    ];

    const {
        recipeTypes,
        fetchAllRecipes,
    } = useRecipesHook();
    
    const { allRecipes } = useSelector((state: RootState) => state.recipe.value);

    const blogTrimesters = [
        {
            id: 1,
            title: 'Trimester - 1',
            value: '1'
        },
        {
            id: 2,
            title: 'Trimester - 2',
            value: '2'
        },
        {
            id: 3,
            title: 'Trimester - 3',
            value: '3'
        },
        {
            id: 4,
            title: 'All',
            value: 'All'
        }
    ];

    const {
        globalTags,
    } = useSelector((state: RootState) => state.tags.value)
    const {
        fetchTags,
    } = useTagsHook();

    const [isModalOpen, setIsModalOpen] = useState(false)
    
    // useEffect to fetch recipes when component mounts
    React.useEffect(() => {
        fetchAllRecipes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        if (searchQuery.trim() === '') {
            fetchAllBlogs();
        } else if (searchQuery.trim().length >= 3) {
            const delaySearch = setTimeout(() => {
                searchBlogs(searchQuery);
            }, 500); // 500ms debounce

            return () => clearTimeout(delaySearch);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery]);

    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(setSelectedBlogData(null))
        dispatch(setSelectedBlogId(''))
        setIsModalOpen(false)
    };
    const onClickOpen = (recipe_: any) => {
        dispatch(setSelectedBlogData(recipe_))
        dispatch(setSelectedBlogId(recipe_._id))
        setIsModalOpen(true)
    }

    if (allBlogs === null) {
        return <div>Loading...</div>
    }

    return (
        <div className='flex justify-center items-center flex-col'>
            <h1 className='text-2xl font-bold'>Update Blogs</h1>
            <h2 className='text-lg font-semibold my-4'>Click on the blog to update</h2>
            
            {/* Search Input */}
            <div className='w-full max-w-2xl my-4 px-4'>
                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search blogs... (min. 3 characters)"
                    className='w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                />
                {searchQuery.trim().length > 0 && searchQuery.trim().length < 3 && (
                    <p className='text-sm text-gray-500 mt-1'>Please enter at least 3 characters to search</p>
                )}
            </div>

            {
                allBlogs.map((blog: any) => {
                    return (
                        <UpdateBlogComponent
                            key={blog._id}
                            id={blog._id}
                            title={blog.blogTitle1}
                            image={blog.blogImage1}
                            isDeleted={blog.isDeleted}
                            onClick={() => onClickOpen(blog)}
                        />
                    )
                })
            }
            {searchQuery.trim() === '' && hasMoreBlogs && (
                <>
                    <InfiniteScrollSentinel
                        onLoadMore={fetchMoreBlogs}
                        disabled={loadingMore}
                    />
                    {loadingMore && <p className="py-4 text-gray-500">Daha fazla yükleniyor...</p>}
                </>
            )}
            {
                isModalOpen === true && selectedBlogId !== '' && selectedBlogData !== null && (
                    <Modal open={isModalOpen} onClose={handleClose}>
                        <Box
                            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 overflow-scroll bg-white p-6 rounded-lg shadow-lg"
                            sx={{
                                width: 750,
                                minHeight: 400,
                                maxHeight: 800,
                            }}
                        >
                            <Typography variant="h6" className="mb-4">
                                Edit Blog - {selectedBlogData.blogTitle1}
                            </Typography>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Blog Title - 1
                                </Typography>
                                <TextField
                                    label='Blog Title - 1'
                                    variant='filled'
                                    style={{ width: '450px', marginBottom: '32px' }}
                                    type="text"
                                    placeholder='Blog Title - 1'
                                    value={selectedBlogData.blogTitle1}
                                    onChange={(e) => dispatch(updateSelectedBlogData({ key: "blogTitle1", value: e.target.value }))}
                                />
                            </div>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 6
                                }}>
                                    Blog Content - 1
                                </Typography>
                                <div style={{ width: '600px', marginTop: '16px', marginBottom: '70px' }}>
                                    <ReactQuill
                                        theme="snow"
                                        value={selectedBlogData.blogDescription1}
                                        onChange={(value) => dispatch(updateSelectedBlogData({ key: "blogDescription1", value }))}
                                        modules={modules}
                                        formats={formats}
                                        style={{
                                            height: '250px',
                                        }}
                                        placeholder="Write blog content here..."
                                    />
                                </div>
                            </div>
                            
                            {/* Blog Image 1 Upload Section */}
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 16
                                }}>
                                    Blog Image - 1
                                </Typography>
                                
                                {/* Current Image Preview */}
                                {selectedBlogData.blogImage1 && (
                                    <div style={{ marginBottom: '16px' }}>
                                        <Typography variant="body2" color="text.secondary" gutterBottom>
                                            Current Image 1:
                                        </Typography>
                                        <img
                                            src={selectedBlogData.blogImage1}
                                            alt="Current Blog 1"
                                            style={{
                                                width: '200px',
                                                height: '150px',
                                                objectFit: 'cover',
                                                borderRadius: '8px',
                                                border: '2px solid #e0e0e0'
                                            }}
                                        />
                                    </div>
                                )}
                                
                                {/* File Upload Input */}
                                <TextField
                                    variant='filled'
                                    style={{ width: '450px', marginBottom: '16px' }}
                                    type="file"
                                    onChange={handleUpdateFileChange1}
                                    inputProps={{ accept: 'image/*' }}
                                />
                                
                                {/* Upload Progress */}
                                {updateUploading1 && (
                                    <div style={{ marginBottom: '16px' }}>
                                        <Typography variant="body2" color="primary">
                                            Image 1 uploading... {Math.round(updateProgress1)}%
                                        </Typography>
                                        <div style={{
                                            width: '450px',
                                            height: '4px',
                                            backgroundColor: '#e0e0e0',
                                            borderRadius: '2px',
                                            overflow: 'hidden',
                                            marginTop: '8px'
                                        }}>
                                            <div style={{
                                                width: `${updateProgress1}%`,
                                                height: '100%',
                                                backgroundColor: '#1976d2',
                                                transition: 'width 0.3s ease'
                                            }} />
                                        </div>
                                    </div>
                                )}
                            </div>
                            
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Blog Title - 2
                                </Typography>
                                <TextField
                                    label='Blog Title - 2'
                                    variant='filled'
                                    style={{ width: '450px', marginBottom: '32px' }}
                                    type="text"
                                    placeholder='Blog Title - 2'
                                    value={selectedBlogData.blogTitle2}
                                    onChange={(e) => dispatch(updateSelectedBlogData({ key: "blogTitle2", value: e.target.value }))}
                                />
                            </div>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 6
                                }}>
                                    Blog Content - 2
                                </Typography>
                                <div style={{ width: '600px', marginTop: '16px', marginBottom: '70px' }}>
                                    <ReactQuill
                                        theme="snow"
                                        value={selectedBlogData.blogDescription2}
                                        onChange={(value) => dispatch(updateSelectedBlogData({ key: "blogDescription2", value }))}
                                        modules={modules}
                                        formats={formats}
                                        style={{
                                            height: '250px',
                                        }}
                                        placeholder="Write blog content here..."
                                    />
                                </div>
                            </div>
                            
                            {/* Blog Image 2 Upload Section */}
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 16
                                }}>
                                    Blog Image - 2
                                </Typography>
                                
                                {/* Current Image Preview */}
                                {selectedBlogData.blogImage2 && (
                                    <div style={{ marginBottom: '16px' }}>
                                        <Typography variant="body2" color="text.secondary" gutterBottom>
                                            Current Image 2:
                                        </Typography>
                                        <img
                                            src={selectedBlogData.blogImage2}
                                            alt="Current Blog 2"
                                            style={{
                                                width: '200px',
                                                height: '150px',
                                                objectFit: 'cover',
                                                borderRadius: '8px',
                                                border: '2px solid #e0e0e0'
                                            }}
                                        />
                                    </div>
                                )}
                                
                                {/* File Upload Input */}
                                <TextField
                                    variant='filled'
                                    style={{ width: '450px', marginBottom: '16px' }}
                                    type="file"
                                    onChange={handleUpdateFileChange2}
                                    inputProps={{ accept: 'image/*' }}
                                />
                                
                                {/* Upload Progress */}
                                {updateUploading2 && (
                                    <div style={{ marginBottom: '16px' }}>
                                        <Typography variant="body2" color="primary">
                                            Image 2 uploading... {Math.round(updateProgress2)}%
                                        </Typography>
                                        <div style={{
                                            width: '450px',
                                            height: '4px',
                                            backgroundColor: '#e0e0e0',
                                            borderRadius: '2px',
                                            overflow: 'hidden',
                                            marginTop: '8px'
                                        }}>
                                            <div style={{
                                                width: `${updateProgress2}%`,
                                                height: '100%',
                                                backgroundColor: '#1976d2',
                                                transition: 'width 0.3s ease'
                                            }} />
                                        </div>
                                    </div>
                                )}
                            </div>
                            
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Blog Title - 3
                                </Typography>
                                <TextField
                                    label='Blog Title - 3'
                                    variant='filled'
                                    style={{ width: '450px', marginBottom: '32px' }}
                                    type="text"
                                    placeholder='Blog Title - 3'
                                    value={selectedBlogData.blogTitle3}
                                    onChange={(e) => dispatch(updateSelectedBlogData({ key: "blogTitle3", value: e.target.value }))}
                                />
                            </div>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 6
                                }}>
                                    Blog Content - 3
                                </Typography>
                                <div style={{ width: '600px', marginTop: '16px', marginBottom: '70px' }}>
                                    <ReactQuill
                                        theme="snow"
                                        value={selectedBlogData.blogDescription3}
                                        onChange={(value) => dispatch(updateSelectedBlogData({ key: "blogDescription3", value }))}
                                        modules={modules}
                                        formats={formats}
                                        style={{
                                            height: '250px',
                                        }}
                                        placeholder="Write blog content here..."
                                    />
                                </div>
                            </div>
                            
                            {/* Blog Image 3 Upload Section */}
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 16
                                }}>
                                    Blog Image - 3
                                </Typography>
                                
                                {/* Current Image Preview */}
                                {selectedBlogData.blogImage3 && (
                                    <div style={{ marginBottom: '16px' }}>
                                        <Typography variant="body2" color="text.secondary" gutterBottom>
                                            Current Image 3:
                                        </Typography>
                                        <img
                                            src={selectedBlogData.blogImage3}
                                            alt="Current Blog 3"
                                            style={{
                                                width: '200px',
                                                height: '150px',
                                                objectFit: 'cover',
                                                borderRadius: '8px',
                                                border: '2px solid #e0e0e0'
                                            }}
                                        />
                                    </div>
                                )}
                                
                                {/* File Upload Input */}
                                <TextField
                                    variant='filled'
                                    style={{ width: '450px', marginBottom: '16px' }}
                                    type="file"
                                    onChange={handleUpdateFileChange3}
                                    inputProps={{ accept: 'image/*' }}
                                />
                                
                                {/* Upload Progress */}
                                {updateUploading3 && (
                                    <div style={{ marginBottom: '16px' }}>
                                        <Typography variant="body2" color="primary">
                                            Image 3 uploading... {Math.round(updateProgress3)}%
                                        </Typography>
                                        <div style={{
                                            width: '450px',
                                            height: '4px',
                                            backgroundColor: '#e0e0e0',
                                            borderRadius: '2px',
                                            overflow: 'hidden',
                                            marginTop: '8px'
                                        }}>
                                            <div style={{
                                                width: `${updateProgress3}%`,
                                                height: '100%',
                                                backgroundColor: '#1976d2',
                                                transition: 'width 0.3s ease'
                                            }} />
                                        </div>
                                    </div>
                                )}
                            </div>
                            
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Blog Trimester
                                </Typography>
                                <Select
                                    style={{ width: '450px', marginBottom: '16px' }}
                                    value={selectedBlogData.blogTrimester}
                                    label="Trimester"
                                    onChange={(e) => dispatch(updateSelectedBlogData({ key: "blogTrimester", value: e.target.value }))}
                                >
                                    {
                                        blogTrimesters.map((option: any) => {
                                            return (
                                                <MenuItem value={option.value}>{option.title}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </div>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Tags
                                </Typography>
                                <Select
                                    multiple
                                    style={{ width: '450px', marginBottom: '16px' }}
                                    value={selectedBlogData.blogTags}
                                    label="Recipe Tag"
                                    // onChange={(e: any) => setRecipeTags(e.target.value)}
                                    onChange={(e) => dispatch(updateSelectedBlogData({ key: "blogTags", value: e.target.value }))}
                                >
                                    {
                                        globalTags.map((option: any) => {
                                            return (
                                                <MenuItem value={option}>{option}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                                <Button
                                    onClick={() => fetchTags()}
                                    style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                                    variant='contained'
                                    color='primary'>
                                    Fetch Tags Manually (If not updated)
                                </Button>
                            </div>
                            
                            {/* Related Recipes Section */}
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Related Recipes
                                </Typography>
                                <Select
                                    multiple
                                    style={{ width: '450px', marginBottom: '16px' }}
                                    value={selectedBlogData.relatedData ? (selectedBlogData.relatedData as any[]).map((item: any) => item.recipeId) : []}
                                    displayEmpty
                                    label="Select Recipe"
                                    renderValue={(selected) => {
                                        if ((selected as string[]).length === 0) {
                                            return <em>Select Recipe</em>;
                                        }
                                        return `${(selected as string[]).length} recipe selected`;
                                    }}
                                    onChange={(e: any) => {
                                        const selectedIds = e.target.value as string[];
                                        const newRelatedData: any[] = [];
                                        
                                        selectedIds.forEach(recipeId => {
                                            const selectedRecipe = allRecipes.find((recipe: any) => recipe._id === recipeId);
                                            if (selectedRecipe) {
                                                newRelatedData.push({
                                                    recipeId: selectedRecipe._id,
                                                    recipeName: selectedRecipe.recipeName,
                                                    recipeImage: selectedRecipe.recipeImage
                                                });
                                            }
                                        });
                                        
                                        dispatch(updateSelectedBlogData({ key: "relatedData", value: newRelatedData }));
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 400,
                                                width: 450,
                                            },
                                        },
                                    }}>
                                    {
                                        allRecipes && allRecipes
                                            .filter((recipe: any) => !recipe.isDeleted) // Silinmiş tarifleri gösterme
                                            .map((recipe: any) => {
                                                const isSelected = selectedBlogData.relatedData ? (selectedBlogData.relatedData as any[]).some((item: any) => item.recipeId === recipe._id) : false;
                                                return (
                                                    <MenuItem key={recipe._id} value={recipe._id}>
                                                        <Checkbox
                                                            checked={isSelected}
                                                            style={{ marginRight: '8px' }}
                                                        />
                                                        <div style={{ 
                                                            display: 'flex', 
                                                            alignItems: 'center',
                                                            width: '100%'
                                                        }}>
                                                            <LazyLoadImage
                                                                src={recipe.recipeImage} 
                                                                alt={recipe.recipeName}
                                                                effect="blur"
                                                                placeholderSrc="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32'%3E%3Crect width='32' height='32' fill='%23f0f0f0'/%3E%3C/svg%3E"
                                                                style={{
                                                                    width: '32px',
                                                                    height: '32px',
                                                                    objectFit: 'cover',
                                                                    borderRadius: '4px',
                                                                    marginRight: '12px',
                                                                    border: '1px solid #ddd'
                                                                }}
                                                            />
                                                            <div style={{ flex: 1 }}>
                                                                <div style={{ 
                                                                    fontSize: '14px',
                                                                    fontWeight: isSelected ? '600' : '500',
                                                                    color: isSelected ? '#1976d2' : 'inherit'
                                                                }}>
                                                                    {recipe.recipeName}
                                                                </div>
                                                                <div style={{ 
                                                                    fontSize: '12px', 
                                                                    color: '#666',
                                                                    marginTop: '2px'
                                                                }}>
                                                                    {recipe.recipeType} • Trimester {recipe.recipeTrimester}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </MenuItem>
                                                );
                                            })
                                    }
                                </Select>
                                
                                {/* Seçilen tarifleri göster */}
                                {selectedBlogData.relatedData && (selectedBlogData.relatedData as any[]).length > 0 && (
                                    <div style={{ width: '450px', marginBottom: '16px' }}>
                                        <Typography sx={{
                                            fontSize: 14,
                                            fontWeight: 600,
                                            color: 'black',
                                            marginBottom: 1
                                        }}>
                                            Seçilen Tarifler ({(selectedBlogData.relatedData as any[]).length})
                                        </Typography>
                                        {(selectedBlogData.relatedData as any[]).map((recipe: any, index: number) => (
                                            <div 
                                                key={recipe.recipeId}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '12px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '8px',
                                                    marginBottom: '12px',
                                                    backgroundColor: '#f9f9f9',
                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                }}
                                            >
                                                <LazyLoadImage
                                                    src={recipe.recipeImage} 
                                                    alt={recipe.recipeName}
                                                    effect="blur"
                                                    placeholderSrc="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60'%3E%3Crect width='60' height='60' fill='%23f0f0f0'/%3E%3C/svg%3E"
                                                    style={{
                                                        width: '60px',
                                                        height: '60px',
                                                        objectFit: 'cover',
                                                        borderRadius: '8px',
                                                        marginRight: '16px',
                                                        border: '2px solid #e0e0e0'
                                                    }}
                                                />
                                                <div style={{ flex: 1 }}>
                                                    <div style={{ 
                                                        fontSize: '16px', 
                                                        fontWeight: '600',
                                                        color: '#333',
                                                        marginBottom: '4px'
                                                    }}>
                                                        {recipe.recipeName}
                                                    </div>
                                                    <div style={{ 
                                                        fontSize: '12px', 
                                                        color: '#666',
                                                        fontStyle: 'italic'
                                                    }}>
                                                        ID: {recipe.recipeId}
                                                    </div>
                                                </div>
                                                <Button
                                                    size="small"
                                                    color="error"
                                                    variant="outlined"
                                                    onClick={() => {
                                                        const updatedRelatedData = (selectedBlogData.relatedData as any[]).filter((_: any, i: number) => i !== index);
                                                        dispatch(updateSelectedBlogData({ key: "relatedData", value: updatedRelatedData }));
                                                    }}
                                                    style={{
                                                        minWidth: '70px',
                                                        fontSize: '12px'
                                                    }}
                                                >
                                                    Kaldır
                                                </Button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            
                            <div className='w-full flex flex-row justify-start items-center my-8'>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                }}>
                                    Deleted:
                                </Typography>
                                <Switch
                                    checked={selectedBlogData.isDeleted}
                                    onChange={(e) => dispatch(updateSelectedBlogData({ key: "isDeleted", value: e.target.checked }))}
                                />
                            </div>
                            <div className='w-full flex flex-row justify-start items-center my-8'>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                }}>
                                    Priority:
                                </Typography>
                                <Switch
                                    checked={selectedBlogData.isPriority}
                                    onChange={(e) => dispatch(updateSelectedBlogData({ key: "isPriority", value: e.target.checked }))}
                                />
                            </div>
                            <div className='flex justify-between w-[300px] mt-4 p-4'>
                                <Button
                                    disabled={
                                        selectedBlogData._id === '' ||
                                        selectedBlogData.blogTitle1 === '' ||
                                        selectedBlogData.blogTrimester === '' ||
                                        selectedBlogData.blogDescription1 === '' ||
                                        selectedBlogData.blogTags === ''
                                    }
                                    variant="contained"
                                    color="primary"
                                    onClick={handleUpdate}
                                    className="mt-4">
                                    Update
                                </Button>
                                <Button
                                    variant="contained"
                                    color="error"
                                    onClick={handleClose}
                                    className="mt-4">
                                    Close
                                </Button>
                            </div>
                            {/* <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Recipe Method
                                </Typography>
                                <TextField
                                    label='Recipe Method'
                                    multiline
                                    variant='filled'
                                    sx={{
                                        width: '450px',
                                        marginBottom: '16px',
                                        '& .MuiInputBase-root': {
                                            minHeight: '250px',
                                            height: 'auto',
                                        },
                                    }}
                                    type="text"
                                    placeholder='Recipe Method'
                                    value={selectedRecipeData.recipeMethod}
                                    onChange={(e) => dispatch(updateSelectedRecipeData({ key: "recipeMethod", value: e.target.value }))}
                                />
                            </div>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Recipe Type
                                </Typography>
                                <Select
                                    style={{ width: '450px', marginBottom: '16px' }}
                                    value={selectedRecipeData.recipeType}
                                    label="Type"
                                    onChange={(e) => dispatch(updateSelectedRecipeData({ key: "recipeType", value: e.target.value }))}
                                >
                                    {
                                        recipeTypes.map((option: any) => {
                                            return (
                                                <MenuItem value={option.value}>{option.title}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </div>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Recipe Trimester
                                </Typography>
                                <Select
                                    style={{ width: '450px', marginBottom: '16px' }}
                                    value={selectedRecipeData.recipeTrimester}
                                    label="Trimester"
                                    onChange={(e) => dispatch(updateSelectedRecipeData({ key: "recipeTrimester", value: e.target.value }))}
                                >
                                    {
                                        recipeTrimesters.map((option: any) => {
                                            return (
                                                <MenuItem value={option.value}>{option.title}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </div>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Preparation Time
                                </Typography>
                                <NumberInput
                                    marginTop={0}
                                    width='450px'
                                    value={selectedRecipeData.recipePreparationTime}
                                    onChange={(value) => dispatch(updateSelectedRecipeData({ key: "recipePreparationTime", value }))}
                                />
                            </div>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Cook Time
                                </Typography>
                                <NumberInput
                                    marginTop={0}
                                    width='450px'
                                    value={selectedRecipeData.recipeCookTime}
                                    onChange={(value) => dispatch(updateSelectedRecipeData({ key: "recipeCookTime", value }))}
                                />
                            </div>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Serves
                                </Typography>
                                <NumberInput
                                    marginTop={0}
                                    width='450px'
                                    value={selectedRecipeData.recipeServes}
                                    onChange={(value) => dispatch(updateSelectedRecipeData({ key: "recipeServes", value }))}
                                />
                            </div>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Ingredients
                                </Typography>
                                <TextField
                                    label='Recipe Ingredients'
                                    variant='filled'
                                    style={{
                                        width: '450px',
                                        marginBottom: '16px',
                                    }}
                                    type="text"
                                    placeholder='Recipe Ingredients'
                                    value={recipeIngredientsForRender}
                                    onChange={(e) => setRecipeIngredientsForRender(e.target.value)}
                                />
                                <Button
                                    disabled={recipeIngredientsForRender === ''}
                                    onClick={() => {
                                        dispatch(updateSelectedRecipeData({ key: "recipeIngredients", value: [...selectedRecipeData.recipeIngredients, recipeIngredientsForRender] }))
                                        setRecipeIngredientsForRender("");
                                    }}
                                    style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                                    variant='contained'
                                    color='primary'>
                                    Add Ingredient
                                </Button>
                                {
                                    selectedRecipeData.recipeIngredients.length > 0
                                        ?
                                        <div>
                                            {
                                                selectedRecipeData.recipeIngredients.map((ingredient: any) => {
                                                    return (
                                                        <div
                                                            key={ingredient}
                                                            className='flex flex-row justify-start items-start'
                                                        >
                                                            <p className='text-lg font-semibold'>* {ingredient}</p>
                                                            <DeleteOutlineIcon
                                                                onClick={() => {
                                                                    // setRecipeIngredients(recipeIngredients.filter((item: any) => item !== ingredient))
                                                                    dispatch(updateSelectedRecipeData({ key: "recipeIngredients", value: selectedRecipeData.recipeIngredients.filter((item: any) => item !== ingredient) }))
                                                                }}
                                                                style={{
                                                                    position: 'relative',
                                                                    cursor: 'pointer',
                                                                    top: '2.5px',
                                                                    left: '8px',
                                                                }}
                                                                color='primary'
                                                            >
                                                                Remove Ingredient
                                                            </DeleteOutlineIcon>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        : null
                                }
                            </div>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Tags
                                </Typography>
                                <Select
                                    multiple
                                    style={{ width: '450px', marginBottom: '16px' }}
                                    value={selectedRecipeData.recipeTags}
                                    label="Recipe Tag"
                                    // onChange={(e: any) => setRecipeTags(e.target.value)}
                                    onChange={(e) => dispatch(updateSelectedRecipeData({ key: "recipeTags", value: e.target.value }))}
                                >
                                    {
                                        globalTags.map((option: any) => {
                                            return (
                                                <MenuItem value={option}>{option}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                                <Button
                                    onClick={() => fetchTags()}
                                    style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                                    variant='contained'
                                    color='primary'>
                                    Fetch Tags Manually (If not updated)
                                </Button>
                            </div>
                            <div className='w-full flex flex-row justify-start items-center my-8'>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                }}>
                                    Premium:
                                </Typography>
                                <Switch
                                    checked={selectedRecipeData.isPremium}
                                    onChange={(e) => dispatch(updateSelectedRecipeData({ key: "isPremium", value: e.target.checked }))}
                                />
                            </div>
                            <div className='w-full flex flex-row justify-start items-center my-8'>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                }}>
                                    Deleted:
                                </Typography>
                                <Switch
                                    checked={selectedRecipeData.isDeleted}
                                    onChange={(e) => dispatch(updateSelectedRecipeData({ key: "isDeleted", value: e.target.checked }))}
                                />
                            </div>
                            <div className='w-full flex flex-row justify-start items-center my-8'>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                }}>
                                    Priority:
                                </Typography>
                                <Switch
                                    checked={selectedRecipeData.isPriority}
                                    onChange={(e) => dispatch(updateSelectedRecipeData({ key: "isPriority", value: e.target.checked }))}
                                />
                            </div>
                            <div>
                                {
                                    dataToUpdates.map((data: any) => {
                                        return (
                                            <div>
                                                <Typography sx={{
                                                    fontSize: 20,
                                                    fontWeight: 600,
                                                    marginBottom: 2,
                                                    marginTop: 4
                                                }}>
                                                    {data.title}
                                                </Typography>
                                                <NumberInput
                                                    marginTop={0}
                                                    width='450px'
                                                    value={
                                                        selectedRecipeData[data.key]
                                                    }
                                                    onChange={(value) => dispatch(updateSelectedRecipeData({ key: data.key, value }))}
                                                />
                                            </div>
                                        )

                                    })
                                }
                            </div>
                            <div className='flex justify-between w-[300px] mt-4 p-4'>
                                <Button
                                    disabled={
                                        selectedRecipeData._id === '' ||
                                        selectedRecipeData.recipeName === '' ||
                                        selectedRecipeData.recipeType === '' ||
                                        selectedRecipeData.recipeTrimester === '' ||
                                        selectedRecipeData.recipePreparationTime === 0 ||
                                        selectedRecipeData.recipeCookTime === 0 ||
                                        selectedRecipeData.recipeServes === 0 ||
                                        selectedRecipeData.recipeTags === '' ||
                                        selectedRecipeData.recipeMethod === '' ||
                                        selectedRecipeData.recipeIngredients.length === 0 ||
                                        selectedRecipeData.recipeIngredients === '' ||
                                        selectedRecipeData.recipeImage === '' ||
                                        selectedRecipeData.recipeCarbs === 0 ||
                                        selectedRecipeData.recipeProtein === 0 ||
                                        selectedRecipeData.recipeFats === 0 ||
                                        selectedRecipeData.recipeCalories === 0 ||
                                        selectedRecipeData.recipeCalcium === "" ||
                                        selectedRecipeData.recipeVitaminA === "" ||
                                        selectedRecipeData.recipeVitaminB6 === "" ||
                                        selectedRecipeData.recipeVitaminB12 === "" ||
                                        selectedRecipeData.recipeVitaminC === "" ||
                                        selectedRecipeData.recipeVitaminD === "" ||
                                        selectedRecipeData.recipeVitaminE === "" ||
                                        selectedRecipeData.recipeVitaminK === "" ||
                                        selectedRecipeData.recipeCholesterol === "" ||
                                        selectedRecipeData.recipeCholine === "" ||
                                        selectedRecipeData.recipeFiber === "" ||
                                        selectedRecipeData.recipeFolicAcid === "" ||
                                        selectedRecipeData.recipeIodine === "" ||
                                        selectedRecipeData.recipeIron === "" ||
                                        selectedRecipeData.recipeMagnesium === "" ||
                                        selectedRecipeData.recipePotassium === "" ||
                                        selectedRecipeData.recipeSaturatedFat === ""
                                    }
                                    variant="contained"
                                    color="primary"
                                    onClick={handleUpdate}
                                    className="mt-4">
                                    Update
                                </Button>
                                <Button
                                    variant="contained"
                                    color="error"
                                    onClick={handleClose}
                                    className="mt-4">
                                    Close
                                </Button>
                            </div> */}
                        </Box>
                    </Modal>
                )
            }
        </div>
    )
}
